interface Options {
    text: string;
    bgColor: string;
    disabled?: boolean;
    isLoading?: boolean;
    onClick: () => void;
}

const NavButton = ({ text, bgColor, disabled, isLoading, onClick }: Options) => {
    return (
        <button
            onClick={onClick}
            style={{ backgroundColor: disabled ? '#B4B9C1' : bgColor }}
            className={`rounded-[4px] md:px-8 md:py-4 px-4 py-2 uppercase font-bold md:text-base text-xs hover:opacity-85 transition-all ${
                disabled ? 'text-gray-bb-2 opacity-70' : 'text-blue-bb-1 cursor-pointer'
            } ${isLoading || disabled ? 'pointer-events-none cursor-not-allowed' : ''}`}
        >
            {isLoading ? 'Enviando...' : text}
        </button>
    );
};

export default NavButton;
